import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import LsType from './LsType.mjs'
import Model from './ModelLs.mjs'

const PropertiesPaneLs = (props) => (
    <ProductPropertiesPane
        controllers={
            <>
                <Text prop="lsName" />

                <Select
                    options={LsType}
                    prop="lsType"
                />

                <Text prop="infDomainName" />
                <Text prop="infIp" />
                <LongText prop="memo" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneLs
